module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/settings-24819356bf1349ac5d7e2035dfed6e4b.svg";